// extracted by mini-css-extract-plugin
export var container = "_hx-0";
export var content = "_hx-3";
export var customerTitle = "_hx-4";
export var empty = "_hx-5";
export var gray = "_hx-6";
export var header = "_hx-7";
export var info = "_hx-8";
export var loading = "_hx-2";
export var loadingCard = "_hx-9";
export var oneLine = "_hx-a";
export var personName = "_hx-e";
export var pillContainer = "_hx-b";
export var selected = "_hx-1";
export var text = "_hx-c";
export var twoLines = "_hx-d";
export var unread = "_hx-f";
export var unreadIndicator = "_hx-g";